







































































import {Vue, Component, Prop, Emit} from 'vue-property-decorator'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import TableEditorsMixin from "../../../mixins/table-editors.mixin";
import {KretanjeVozila} from "@/services/BackendProxies";

@Component({})
export default class KretanjaPutnogNaloga extends mixins(ComponentBaseMixin, TableEditorsMixin) {
    @Prop() kretanja!: KretanjeVozila[];

    dodajKretanje(row: KretanjeVozila) {
        setTimeout(() => {
            if (row instanceof MouseEvent) {
                const index = this.kretanja.length ? this.kretanja.length - 1 : null;
                if (index || index === 0) {
                    row = this.kretanja[index];
                }
            }
            this.kretanja.push(KretanjeVozila.fromJS({
                datumPolaska: row.datumDolaska ? row.datumDolaska : new Date(),
                kilometrazaPolaska: row.kilometrazaDolaska
            }));
        }, 100);
    }

    predjenaKM(row: KretanjeVozila) {
        if (row.kilometrazaPolaska && row.kilometrazaDolaska) {
            return `${row.kilometrazaDolaska - row.kilometrazaPolaska} km`
        } else {
            return '';
        }
    }

    fokusirajCeliju(dataCellValue) {
        this.$nextTick(() => {
            $(`[data-cell="${dataCellValue}"]`).focus();
        })
    }

    onClickCell(row) {
        const lastRow = this.kretanja.length ? this.kretanja[this.kretanja.length - 1] : null;
        if (lastRow == row) {
            this.obrisiKretanje(row);
        }
    }

    @Emit() obrisiKretanje(row: KretanjeVozila) {
    }
}
